import { z } from 'zod'
import { VENUE_PAGE_DESCRIPTION_MAX } from '../constants/venue-public-page.js'
import { clearable, websiteSchema } from './vendor-profile.input.js'

/**
 * Changes to a venue's page on the public site, from Venue setup
 * (docs/public-site.spec.md). Each field is optional; a blank description or
 * website clears it. Turning the page on is refused while it still needs
 * something.
 */
export const updateVenuePublicPageInputSchema = z
  .object({
    on: z.boolean().optional(),
    /** List the venue's vendors that have pages. Needs nothing: it can be on while the page itself is off. */
    vendorsOn: z.boolean().optional(),
    description: clearable(z.string().trim().max(VENUE_PAGE_DESCRIPTION_MAX, `Keep it to ${VENUE_PAGE_DESCRIPTION_MAX.toLocaleString('en-US')} characters`)),
    website: clearable(websiteSchema),
  })
  .strict()

export type UpdateVenuePublicPageInput = z.infer<typeof updateVenuePublicPageInputSchema>
